import { useWeb3React } from '@web3-react/core';
import { useContext } from 'react';
import useSWR from 'swr';
import appContext from '../../../context/app/appContext';
import { sleep } from '../../../web3/utils';

const useUserAccumulatedVoSpool = () => {
    const { account } = useWeb3React();

    const { interfaceSDK } = useContext(appContext);

    const { data, error, mutate } = useSWR(
        interfaceSDK && account ? ['userAccumulatedVoSpool', account] : null,
        (_, userAddress) => interfaceSDK!.get.getAccumulatedVoSpool(userAddress)
    );

    const update = async (previousValue?: string) => {
        if (!previousValue) {
            return mutate(undefined, true);
        }

        let retries = 0;

        do {
            const currentValue = await mutate(undefined, true);

            if (currentValue !== previousValue) {
                break;
            }

            retries++;
            await sleep(3000);
        } while (retries < 5);
    };

    return {
        userAccumulatedVoSpool: data,
        isLoading: !error && !data,
        error,
        updateUserAccumulatedVoSpool: update,
    };
};

export default useUserAccumulatedVoSpool;
